import { useContext } from 'react';
import {
  useSelectedWorkspace,
  useToken,
} from '../../Flow/ConsentContextProvider';
import { ReactMcpContext } from './McpContextProvider';
import {
  MCP_RESUME_FORM_FIELDS,
  MCP_SELECTED_TOOLSETS_SEPARATOR,
} from './domain/contract';
import { buildMcpSelectedScopesForPost } from './domain/scopeSelection';

const McpFlowParameters = () => {
  const mcpContext = useContext(ReactMcpContext);
  const { selectedWorkspace } = useSelectedWorkspace();
  const token = useToken();

  const selectedNames =
    mcpContext?.mcpSelectedToolsetNames ?? new Set<string>();
  const byIntent = mcpContext?.mcpByIntent ?? [];
  const allToolsets = byIntent.flatMap((g) => g.toolsets);

  // Only post names that are still in the effective toolset list
  const allNames = new Set(allToolsets.map((t) => t.name));
  const postedNames = [...selectedNames].filter((name) => allNames.has(name));

  const selectedScopesJoined = buildMcpSelectedScopesForPost(
    postedNames,
    allToolsets,
    token.scopes,
  ).join(' ');

  const selectedToolsetsJoined = postedNames.join(
    MCP_SELECTED_TOOLSETS_SEPARATOR,
  );
  const selectedTrelloWorkspaceIds = mcpContext?.scopeClassification.hasTrello
    ? mcpContext.selectedTrelloWorkspaces
        .map((workspace) => workspace.id)
        .filter(Boolean)
    : [];
  const selectedBitbucketWorkspaceIds = mcpContext?.isBitbucketWorkspaceAccessEnabled
    ? mcpContext.selectedBitbucketWorkspaces.map((ws) => ws.ari)
    : [];
  const selectedWorkspaceIds = [
    ...(mcpContext?.scopeClassification.hasAtlassian && selectedWorkspace
      ? [selectedWorkspace]
      : []),
    ...selectedTrelloWorkspaceIds,
    ...selectedBitbucketWorkspaceIds,
  ];

  return (
    <>
      <input
        type="hidden"
        name={MCP_RESUME_FORM_FIELDS.selectedScopes}
        value={selectedScopesJoined}
      />
      <input
        type="hidden"
        name={MCP_RESUME_FORM_FIELDS.selectedToolsets}
        value={selectedToolsetsJoined}
      />
      {selectedWorkspaceIds.map((workspaceId) => (
        <input
          key={workspaceId}
          type="hidden"
          name="selectedWorkspace"
          value={workspaceId}
        />
      ))}
    </>
  );
};

export default McpFlowParameters;
